(function ($) {

	function new_map($el) {
		var $markers = $el.find('.marker');

		var args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 300),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#f5f5f5"
					}
				  ]
				},
				{
				  "elementType": "labels.icon",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#616161"
					}
				  ]
				},
				{
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#f5f5f5"
					}
				  ]
				},
				{
				  "featureType": "administrative",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "administrative",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "administrative",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "administrative.land_parcel",
				  "elementType": "labels",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "administrative.land_parcel",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "administrative.land_parcel",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "landscape",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "landscape",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#eeeeee"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels",
				  "stylers": [
					{
					  "color": "#002f5c"
					},
					{
					  "visibility": "on"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels.icon",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					},
					{
					  "visibility": "on"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#002f5c"
					},
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "poi.park",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#e5e5e5"
					}
				  ]
				},
				{
				  "featureType": "poi.park",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#9e9e9e"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#ffffff"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "geometry.stroke",
				  "stylers": [
					{
					  "color": "#d9e0e7"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "road.arterial",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#757575"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#ffffff"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "labels",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "labels.text",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#002f5c"
					}
				  ]
				},
				{
				  "featureType": "road.local",
				  "elementType": "labels",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "transit.line",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#e5e5e5"
					}
				  ]
				},
				{
				  "featureType": "transit.station",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#eeeeee"
					}
				  ]
				},
				{
				  "featureType": "water",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#c9c9c9"
					}
				  ]
				},
				{
				  "featureType": "water",
				  "elementType": "geometry.fill",
				  "stylers": [
					{
					  "color": "#a1b2c3"
					}
				  ]
				},
				{
				  "featureType": "water",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#9e9e9e"
					}
				  ]
				}
			  ]
		};

		// create map
		var map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			add_marker($(this), map);
		});

		// center map
		center_map(map);

		// return
		return map;
	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker($marker, map) {
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
		var markerLabel = $marker.attr('data-label');

		// create marker
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: {
				url: ajax.themeurl + '/assets/img/pin.svg',
				scaledSize: new google.maps.Size(283, 117),
				labelOrigin: new google.maps.Point(78, 20)
			},
			
		});

		// add to array
		map.markers.push(marker);		
	}

	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map(map) {
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(16);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}

		map.panBy(0, -58)

	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	var map = null;

	$(function () {
		$('.js-simple-map').each(function () {
			map = new_map($(this));
		});
	});

})(jQuery);